const states = {
  inProgress: 1,
  done: 2,
  error: 3
}

export default {
  data: function () {
    return {
      state: 0,
      error: ''
    }
  },
  computed: {
    inProgress: function () {
      return this.state === states.inProgress
    },
    isDone: function () {
      return this.state === states.done
    },
    isError: function () {
      return this.state === states.error
    },
    userName: function () {
      return this.$store.getters.currentUser.userName
    },
    lastNameQuestionList: function () {
      return ['oas-judge-last-name', 'oasam-student-last-name', 'Ohio-Mentor: Last Name', 'oasam-last-name', 'Ysc: Last Name', 'OhioStudent: Last Name', 'Last Name']
    },
    firstNameQuestionList: function () {
      return ['oas-judge-first-name', 'oasam-student-first-name', 'Ohio-Mentor: First Name', 'oasam-first-name', 'Ysc: First Name', 'OhioStudent: First Name', 'First Name']
    },
    isProjectSubmitForm: function () {
      return this.formInfo?.name.includes('Project_Submission_User_Info') || this.formInfo?.name.includes('Project_Submission_Project_Info') || this.formInfo?.name.includes('Project_Submission_Payment_Info')
    },
    formInfo: function () {
      return this.$store.getters.formInfo
    }
  }
}
